<template>
  <div>
    <!-- @hide="popoverHide" -->
    <!-- v-model="isShowSelect" -->
    <el-popover placement="bottom-start" trigger="click">
      <el-tree
        class="common-tree"
        ref="tree"
        :data="data"
        :props="defaultProps"
        :show-checkbox="multiple"
        :node-key="nodeKey"
        :default-checked-keys="defaultCheckedKeys"
        :highlight-current="true"
        @check-change="handleCheckChange"
      ></el-tree>
      <!-- :multiple="multiple" 可以多选 -->
      <!-- :clearable="clearable" 可以删除 -->
      <span></span>
      <el-select
        slot="reference"
        ref="select"
        v-model="value"
        class="tree-select"
        style="width:22%"
        @click.native="isShowSelect = !isShowSelect"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "tree-select",
  props: {
    // 树结构数据
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultProps: {
      type: Object,
      default() {
        return {};
      }
    },
    // 配置是否可多选
    multiple: {
      type: Boolean,
      default() {
        return false;
      }
    },
    nodeKey: {
      type: String,
      default() {
        return "id";
      }
    },
    // 默认选中的节点key数组
    checkedKeys: {
      type: Array,
      default() {
        return [];
      }
    },
    clearable: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      defaultCheckedKeys: [],
      isShowSelect: false, // 是否显示树状选择器
      options: [],
      value: "未分配",
      selectedData: [] // 选中的节点
    };
  },
  mounted() {
    if (this.checkedKeys.length > 0) {
      if (this.multiple) {
        //多选
        this.defaultCheckedKeys = this.checkedKeys; //选中的节点key数组
        this.value = "已分配";
        this.selectedData = this.checkedKeys.map(item => {
          var node = this.$refs.tree.getNode(item); // 根据 data 或者 key 拿到 Tree 组件中的 node
          return node.label;
        });
      } else {
        var item = this.checkedKeys[0];
        var node = this.$refs.tree.getNode(item);
        this.selectedData = node.label;
      }
    } else {
      this.value = "未分配";
    }
  },
  methods: {
    popoverHide() {
      if (this.multiple) {
        this.$refs.tree.getCheckedKeys(); // 当前被选中的节点的 key 所组成的数组数据
        this.$refs.tree.getCheckedNodes(); // 当前被选中的节点所组成的数组数据
        var ridsa = this.$refs.tree
          .getCheckedKeys()
          .concat(this.$refs.tree.getHalfCheckedKeys());
      } else {
        this.$refs.tree.getCurrentKey(); //使用此方法必须设置 node-key 属性
        this.$refs.tree.getCurrentNode(); //获取当前被选中节点的 data，若没有节点被选中则返回 null
      }
      this.$emit("getMenuIds", ridsa);
    },
    // 节点选中状态发生变化时的回调
    handleCheckChange() {
      var checkedKeys = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys()); // 所有被选中的节点的 key 所组成的数组数据
      this.$emit("getMenuIds", checkedKeys);
      // this.options = checkedKeys.map(item => {
      //   var node = this.$refs.tree.getNode(item); // 根据 data 或者 key 拿到 Tree 组件中的 node
      //   let tmpMap = {};
      //   tmpMap.value = node.key;
      //   tmpMap.label = node.label;
      //   return tmpMap;
      // });
      // this.selectedData = this.options.map(item => {
      //   return item.label;
      // });
    },
    removeSelectedNodes() {},
    changeSelectedNodes(selectedData) {
      // 多选,清空select输入框时，清除树勾选
      if (selectedData.length <= 0) {
        this.clearSelectedNodes(selectedData);
      }
    },
    clearSelectedNodes() {
      var checkedKeys = this.$refs.tree.getCheckedNodes(); // 所有被选中的节点的 key 所组成的数组数据
      for (let i = 0; i < checkedKeys.length; i++) {
        this.$refs.tree.setChecked(checkedKeys[i], false);
      }
    }
  },
  watch: {
    isShowSelect() {
      // 隐藏select自带的下拉框
      this.$refs.select.blur();
    }
  }
};
</script>

<style scoped>
.common-tree {
  overflow: auto;
}
</style>

<style>
/* .tree-select .el-select__tags .el-tag .el-tag__close {
  display: none;
}
.tree-select .el-select__tags .el-tag .el-icon-close {
  display: none;
} */
</style>
